import { Skeleton } from '../../Skeleton'

import * as styles from './WidgetHeaderSkeleton.module.css'

function WidgetHeaderSkeleton({ className = styles.WidgetHeaderSkeleton }) {
  return <Skeleton className={className} />
}

export default WidgetHeaderSkeleton
